<template>
  <b-container >
    <div class="row" style="margin-top:5rem;">
      <div class="col-md-12">
          <b-card class="col-md-6 ml-auto mr-auto">
            <div   class="row">
              <div  class="col-md-12">
                <h4><b>POST YOUR ADD</b> </h4>
                <p class="left-aligned">Click to Upload Media</p>
                <input style="display:none;" multiple ref="FileInput" @change="onFilePicked" type="file" >
                <img v-if="total_files.length<1" @click="onPickFile" src="img/sellmodal/camera.png" width="50" align="left">
                <p v-else class="left-aligned"><span class="fa fa-check fa-3x text-success left-aligned text-right" aria-hidden="true"></span> </p>
                <video v-if="video!=''" id="my-video" style="height:163px;" width="450" controls :src="video"></video>
              </div>
              <div style="text-align:left !important" class="col-md-12 mt-3">
                <p class="left-aligned">Add Type</p>
                <b-button :variant="new_post.sale==true ? success:outline_success" class="text-left rounded-pill" @click="new_post.sale=true">For Sale</b-button>
                <b-button :variant="new_post.sale==false ? success:outline_success" class="rounded-pill ml-1" @click="new_post.sale=false">Not For Sale</b-button>
              </div>
              <div style="text-align:left !important" class="col-md-12 mt-3">
                <p class="left-aligned">Select Category</p>
                <b-button :variant="new_post.category=='cow' ? success:outline_success" class="text-left rounded-pill" @click="new_post.category='cow'">Cow</b-button>
                <b-button :variant="new_post.category=='goat' ? success:outline_success" class="ml-1 rounded-pill" @click="new_post.category='goat'">Goat</b-button>
                <b-button :variant="new_post.category=='sheep' ? success:outline_success" class="ml-1 rounded-pill" @click="new_post.category='sheep'">Sheet</b-button>
                <b-button v-if="loggedUser.id==21" :variant="new_post.category=='Sadqa' ? success:outline_success" class="ml-1 rounded-pill" @click="new_post.category='Sadqa'">Sadqa</b-button>
                <b-button v-if="loggedUser.id==21" :variant="new_post.category=='Aqiqa' ? success:outline_success" class="ml-1 rounded-pill" @click="new_post.category='Aqiqa'">Aqiqa</b-button>

              </div>
              <div style="text-align:left !important" class="col-md-12 mt-3">
                <p class="left-aligned">Animal Information</p>
                    <b-form-input  placeholder="City" v-model="new_post.city"></b-form-input>
                    <b-form-input class="mt-2" v-model="new_post.price" placeholder="Price"></b-form-input>
                    <b-form-input class="mt-2" v-model="new_post.contactno" placeholder="Contact Number"></b-form-input>
                    <b-input-group class="mt-2" >
                    <b-form-input v-model="new_post.weight" placeholder="Weight"></b-form-input>

                        <template v-slot:append>
                          <b-dropdown :text="new_post.weight_unit" variant="success">
                            <b-dropdown-item @click="new_post.weight_unit='KG'">KG</b-dropdown-item>
                            <b-dropdown-item @click="new_post.weight_unit='Mann'">Mann</b-dropdown-item>
                          </b-dropdown>
                        </template>
                      </b-input-group>
                    <b-form-textarea
                      class="mt-2"
                      placeholder="Description..."
                      rows="3"
                      v-model="new_post.description"
                      max-rows="6"
                    ></b-form-textarea>

              </div>
              <div class="col-md-12 mt-4">
                <b-button v-if="isload==false" class="text-center" variant="success" @click="createNewPost">UPLOAD</b-button>
                <b-spinner v-else  variant="success" label="Spinning"></b-spinner>

              </div>
            </div> 
          </b-card>
      </div>
    </div>
  </b-container>

  <!-- </div> -->
</template>

<script>
import S3 from 'aws-s3';
import { RepositoryFactory } from '../Repository/RepositoryFactory'
const PostsRepository = RepositoryFactory.get('posts_repository')
const UserRepository = RepositoryFactory.get('user_repository')
const OrderRepository = RepositoryFactory.get('order_repository')

const config = {
    bucketName: 'qurbaniimages',
    region: 'us-east-1',
    accessKeyId: 'AKIA44SH2DQ6DKA4TH7T',
    secretAccessKey: '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',
    s3Url: 'https://qurbaniimages.s3.us-east-1.amazonaws.com/', /* optional */

}
 const S3Client = new S3(config);
import {mapGetters} from 'vuex'
  import { uuid } from 'vue-uuid'; // uuid object is also exported to things
import captureVideoFrame from 'capture-video-frame'

export default {
props:['type'],
name:'NewPost',
 data(){
   return{
     isload:false,
      video: "",
     total_files:[],
     datums:'',
      uuid: uuid.v1(),
     new_post:{
      imagekey: "",
      description: "",
      user_id: '',
      category: "cow",
      post_type: "AUDIO",
      sale: true,
      sadqa:false,
      city: "",
      weight: "",
      weight_unit:"KG",
      price: "",
      contactno: "",
      thumbnail: "",
      featured: "false"
      },
     outline_success:'outline-success',
     success:'success',
   }
 },
 computed:{
    ...mapGetters(['loggedUser']),
 },
 created(){
   if(this.type!=null){
       this.new_post.post_type=this.type
   }
   
 },
 methods:{
    async getUserResources() {
      if(this.loggedUser.id==21){
           this.fetchAdminAllSadqahOrders()
      }
      else{
        localStorage.removeItem("user_resources");
        var {data}= await UserRepository.get_user_resources({user_id:this.loggedUser.id})
        this.$store.commit("setUserResources",data)
      
      }
      this.$router.push({name:'AllPosts',params:{types:1}})

    },
    async fetchAdminAllSadqahOrders() {
         var {data}= await OrderRepository.get_admin_sadqa_orders()
         this.$store.commit("setAdminResources",data[0])
    },
   onPickFile()
    { 
      this.$refs.FileInput.click();
    },
        // var video = document.querySelector('video');
        // video.src = window.URL.createObjectURL(files[0]);
        // URL.createObjectURL(this.files[0])
    onFilePicked(event)
      { 

        let tem_img_key=''
        const files=event.target.files;
        console.log(files[0].type.split('/')[0])
        if( this.type=='VIDEO'){
          if(files[0].type.split('/')[0]=='video'){
          this.video= URL.createObjectURL(files[0])

          files.forEach((item,i)=>{
              let newkey=uuid.v1()
              this.total_files.push({image:item,image_name:newkey+'.'+item.name.split('.')[1]})

              if(i==0){

              tem_img_key=','+newkey+'.'+item.name.split('.')[1]

              }
              else{
              tem_img_key=tem_img_key+','+newkey+'.'+item.name.split('.')[1]

              }
            })        
            this.new_post.imagekey=tem_img_key

          }
          else{
              this.$store.commit('setNotifications',{message:'Select a video file ',type:'error'})
          }
        }
        if( this.type=='AUDIO'){
        if(files[0].type.split('/')[0]=='image'){
                files.forEach((item,i)=>{
                  let newkey=uuid.v1()
                  this.total_files.push({image:item,image_name:newkey+'.'+item.name.split('.')[1]})

                  if(i==0){

                  tem_img_key=','+newkey+'.'+item.name.split('.')[1]

                  }
                  else{
                  tem_img_key=tem_img_key+','+newkey+'.'+item.name.split('.')[1]

                  }
                })        
                this.new_post.imagekey=tem_img_key

        }
        else{
            this.$store.commit('setNotifications',{message:'Select an image file ',type:'error'})
        }
        }
        

        
      },
    async createNewPost() {
      if(this.new_post.category=='Sadqa'){
        this.new_post.sadqa=true
      }
      else{
        this.new_post.sadqa=false

      }
      this.isload=true
      if(this.type=='VIDEO') {
      var frame = captureVideoFrame('my-video', 'png');
      var thumbnail_file = new File([frame.blob], 'temps', {
      type: "img/"+frame.format,
      });
      console.log(frame)
      var thumbnail_name=uuid.v1()+'.'+frame.format
      this.new_post.thumbnail=thumbnail_name
      S3Client
          .uploadFile(thumbnail_file, thumbnail_name)
          .then((data) => {
            console.log(data)
          })
          .catch(err => console.error(err))
      }
      // })
     if(this.new_post.description!="" && this.new_post.price!="" && this.new_post.weight!=""  && this.new_post.contactno!="" ){
      this.total_files.forEach((item,i)=>{
        console.log("saffffes")
        let self=this
        S3Client
          .uploadFile(item.image, item.image_name)
          .then((data) => {
            if(this.total_files.length==i+1){
              self.isload=false
              this.$store.commit('setNotifications',{message:'Your post has been created',type:'success'})
              this.getUserResources()

            }

          })
          .catch(err => console.error(err))
      
      })
      
          this.new_post.user_id=this.loggedUser.id
          var {data}= await PostsRepository.new_post(this.new_post)
          // this.$store.commit('setNotifications',{message:'Your post has been created',type:'success'})
          // this.total_files=[]
          this.new_post={
              imagekey: "",
              description: "",
              user_id: '',
              category: "cow",
              post_type: "AUDIO",
              sale: true,
              sadqa:false,
              city: "",
              weight: "",
              price: "",
              contactno: "",
              thumbnail: "",
              featured: "false"
              }
          this.video=''    

     }
     else{
          this.$store.commit('setNotifications',{message:'Make sure to fill in all details',type:'error'})

     }

   }
 }
}
</script>

<style>

</style>